<template>
<div class="container">
                <h2 class="h2 section-title underline">PARTNERS</h2>

        <div class="imagem" id="Partners">
        <div class="patner">
            <a href="https://ra-po.cv/" target="_blank">
                            <img src="/img/consultores.png" alt="">

            </a>
        </div>
        <div class="patner">
                     <a href="https://rise.ao" target="_blank">
                        <img src="/img/risepatners.png" alt="">
</a>
        </div>
        <div class="patner">
             <a href="https://www.mira.co.ao/" target="_blank">
         <img src="/img/mira.png" alt="">
</a>
        </div>
        <div class="patner">
                    <a href="https://www.ucall.co.ao/" target="_blank">
           <img src="/img/ucall.png" alt="">
           </a>
        </div>

    </div>
</div>
</template>

<style scoped>
.imagem{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 8%;

}
.patner{
    width: 25%;
}
.patner img{
    width: 100%;
}
.container{
    margin-top: 4%;
}
.section-title{
    margin-bottom: 0 !important;
}
.patner:hover{
    transform: scale(1.05);
    transition: transform 0.3s ease;

}
@media (max-width: 576px){
  .patner {
    width: 50%;
    margin-bottom: 2%;
 }
}


</style>

